import LeadList from '_modules/lead/views/LeadList.vue';
import LeadView from '_modules/lead/views/LeadView.vue';
import Lead from './Root.vue';

export default {
  path: 'indicacoes/',
  component: Lead,
  name: 'admin-lead',
  redirect: '/indicacoes/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-lead-list',
      component: LeadList,
    },
    {
      path: ':leadId',
      name: 'admin-lead-view',
      component: LeadView,
    },
  ],
};
